import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@fitness-force/environments';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { StafAvailabilityConfigResponse } from '../models/staff-availability-config';
import { StaffAppointmentTytpeLinkResponse } from '../models/StaffAppointmentTytpeLink';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class StaffAppointmentTypeLinkService {
  private http = inject(HttpClient);
  private router = inject(Router);


  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  GetStaffAppointmentLink(tenantId: number, staffId: number):Observable<StafAvailabilityConfigResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF_AVAILABILITY.GET_STAFF_APPOINTMENT_TYPE_LINKS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{staff_id}', staffId.toString());
    return this.http.get(url, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetStaffAppointmentLinkByCategoryId(tenantId: number, appointmentCategoryId: number):Observable<StaffAppointmentTytpeLinkResponse>
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.STAFF_AVAILABILITY.GET_ASSIGNED_STAFFS_BY_APPOINTMENT_CATEGORY
      .replace('{tenant_id}', tenantId.toString())
      .replace('{appointment_category_id}', appointmentCategoryId.toString());
    return this.http.get(url, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
